import React from "react"
import {Col, Row} from 'react-bootstrap'
// import VenueLocationOtp from "../../account-setup/venue-location/VenueLocationOtp";
import AvatarSkeleton from "../../../../components/skeletons/AvatarSkeleton";
import InputFieldSkeleton from "../../../../components/skeletons/InputFieldSkeleton";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";

export default function EditProfileSkeleton(options) {

    return(
        <div className={'signup'}>
            <div>
                <Row>
                    <Col md={12}>
                        <div className={'form-avatar'}>
                            <div className={'dfields'}>
                                <AvatarSkeleton avatarShape={'circle'} height={90} width={90}/>
                            </div>
                        </div>
                    </Col>
                    <InputFieldSkeleton/>
                    <InputFieldSkeleton/>
                    <InputFieldSkeleton/>
                </Row>


                <div className={'dfields'}>
                    <HeadingSkeleton height={50}/>
                </div>
            </div>
        </div>
    )
}